import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const fundGeographicalFocusSelector = ({ fundGeographicalFocus }: ReducerState) => fundGeographicalFocus;
export const fundGeographicalFocusLoadingSelector = createSelector(
  fundGeographicalFocusSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
